import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Container from './Container';
import Navbar from '../../Header/NavBar/NavBar';
import BigTitle from '../../BigTitle/BigTitle';

function Layout({ children }) {
  const isAuth = useSelector(state => state.auth.jwtToken !== null);
  return (
    <Container>
      <Navbar isAuth={isAuth} />
      <BigTitle />
      <div className="page-content">
        {children}
      </div>
    </Container>
  );
}

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default Layout;
